<app-Loading
  *ngIf="isLoading$ | async"
  [progressbarValue]="progressbarValue$|async"
/>
<div class="softrate-wrapper container-fluid">
  <div class="rate-header pt-4">
    <p class="rate-mainhead">Done! Your quotes are here!</p>
    <p class="rate-subhead">
      Click Show Details to see more information, or Move Forward to pick your quote.
    </p>
  </div>
  <!-- slider -->
  <div class="slider" *ngIf="false">
    <div class="tabs">
      <input
        type="radio"
        id="radio-1"
        name="tabs"
        (click)="setTab(1)"
        [checked]="(tabPosition$|async) === 1"
      />
      <label class="tab" for="radio-1">Auto</label>
      <input
        type="radio"
        id="radio-2"
        name="tabs"
        (click)="setTab(2)"
        [checked]="(tabPosition$|async) === 2"
      />
      <label class="tab" for="radio-2">Home</label>
      <input
        type="radio"
        id="radio-3"
        name="tabs"
        (click)="setTab(3)"
        [checked]="(tabPosition$|async) === 3"
      />
      <label class="tab" for="radio-3">Auto + Home<span class="notification">-15%</span></label>
      <span class="glider"></span>
    </div>
  </div>

  <!-- Details list -->
  <ul>
    <li
      *ngFor="let quote of quotes$ | async; let i = index"
      class="details-wrapper"
    >
      <div
        class="details-list"
        [ngClass]="(details$|async) === i ? 'active-list' : ''"
      >
        <div class="details-body">
          <div class="details-data">
            <div class="details-title">
              <img class="carrier-logo" [src]="quote.carrier.logo" alt="">
              <p class="details-head">{{displayPremium(quote) | currency: 'USD':'symbol':'1.0-0' }}/mo.</p>
            </div>
          </div>
          <div class="plan-rate"></div>
          <div class="details-btn-wrapper">
            <button class="details-btn" (click)="viewDetails(i)">
              <ng-container *ngIf="(details$|async) === i; else showDetailsTemplate">
                Hide Details
                <fa-icon [icon]="icons.arrow_up"></fa-icon>
              </ng-container>
              <ng-template #showDetailsTemplate>
                Show Details
                <fa-icon [icon]="icons.arrow_down"></fa-icon>
              </ng-template>
            </button>
            <button class="price-btn" (click)="selectQuote(quote)">
              Move Forward
            </button>
          </div>
        </div>
        <div
          *ngIf="(details$|async) === i"
          class="sub-details fade"
          [ngClass]="(details$|async) === i ? 'fade' : 'fade-hide'"
          [@state]="state$|async"
        >
          <div class="sub-col1">
            <h3 class="sub-head">Policy Coverage</h3>
            <div
              *ngFor="let coverage of quote.policyCoverages; let i = index"
              class="sub-list"
            >
              <span>{{ coverage.description }}</span>
              <span>
                <span *ngFor="let item of coverage.amounts; last as isLast"
                >{{
                    item.amount
                      | currency: 'USD':'symbol':'1.0-2'
                      | thousands
                  }}{{ !isLast ? '/' : '' }}</span
                >
              </span>
            </div>
            <ng-container *ngIf="quote?.policyCoverages?.length === 0">
              No coverage
            </ng-container
            >
          </div>
          <!-- <div class="sub-divider"></div> -->
          <div class="sub-col2">
            <h3 class="sub-head">Vehicle Coverage</h3>
            <div
              *ngFor="let coverage of quote.vehicleCoverages; let i = index"
              class="sub-list"
            >
              <span>{{ coverage.description }}</span>
              <span>{{ coverage.value }}</span>
            </div>
            <ng-container *ngIf="quote.vehicleCoverages.length === 0">
              <div>No coverage</div>
            </ng-container>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>

<div class="mt-auto flex flex-col gap-4 p-4 lg:p-6 border-t border-neutral-400 border-solid bg-white text-black">
  <h4>Limitation of Liability</h4>
  <div class="flex flex-col gap-2">
    <p class="text-sm">
      Please note that you may not bind, alter, cancel, or change policy coverages via email, website,
      or voicemail system. All quotes and coverage are subject to review and approval by a licensed
      agent.
      To the fullest extent permitted by law, TopLine Insurance Agency shall not be liable for any
      injury, loss, claim, or damage, nor any indirect, special, incidental, or consequential damages of
      any kind, whether based on contract, tort, strict liability or otherwise, which arises out of (a) the
      use of, or inability to use, this site or content found in this site, or (b) unless resulting from the
      gross negligence or intentional actions of TopLine Insurance Agency, the unauthorized access
      to or alteration of your transmissions or data, even if TopLine insurance Agency has been
      advised of the possibility of such damages.
    </p>
  </div>
  <h4>Privacy Disclaimer</h4>
  <div class="flex flex-col gap-2">
    <p class="text-sm">
      The security of all information associated with our users is an important concern to our team.
      We exercise care in providing secure transmission of your information from your computer to
      our and our affiliates' servers. Unfortunately, no data transmission over the Internet can be
      guaranteed to be 100% secure. As a result, while we strive to protect your personal information,
      we cannot ensure or warrant the security of any personal information you transmit to us or from
      our online products and services, and you do so at your own risk. Once we receive your
      transmission, we, including our affiliates, use industry-standard efforts to safeguard the
      confidentiality of your personal information, such as firewalls and secure socket layers.
      However, "perfect security" does not exist on the Internet.
    </p>
  </div>
</div>
